import authRquest from '../helpers/authorizateRequest'
import botsRequest from '../helpers/botsRequest'
// Every caller names its endpoint; a missing one is a programming error, not a request.
function endpointOf(url) {
    if (!url) throw new Error('request: endpoint is required')
    return url
}

export default {
    getParams(params) {
        if(!params) return ''
        if(typeof params == 'string') return params

        if(params.length) {
            let _params =''
            params.forEach(param => {
                const t = '/'+this.getParam(param)
                _params += t == '/' ? '': t
            });
            return _params.replace('//','/').replace('/?', '?')
        } else {
            return this.getParam(params)
        }
    },

    getParam(param) {
        if(typeof param == 'string' || typeof param == 'number') return param
        if(param.length) {
            return param.join('/');
        } else {
            const temp= new URLSearchParams(param).toString(); // return param1=something&param2=somethingelse ... 
            return temp? '?'+temp : ''
        }
    },
    

    async get(payload, url, param, requestType, config) {
        
        
        const paramStr = this.getParams(param); // Для формирования сегментов пути
        const payloadStr = this.getParams(payload); // Для формирования query string
    
        // Объединяем параметры
        const query = paramStr + (payloadStr ? (paramStr.includes('?') ? '&' : '?') + payloadStr.slice(1) : '');
    
        // Устанавливаем конечную точку
        const endpoint = endpointOf(url); 
        let requestFn = requestType === 'bots' ? botsRequest : authRquest
        const { data } = await requestFn.get(`${endpoint}${query.replaceAll('//','/')}`, config);
        return data;
        
    },
        
    async put(payload, url, param, requestType) {
        param = this.getParams(param)
        const endpoint = endpointOf(url)
        let requestFn = requestType === 'bots' ? botsRequest : authRquest
        const { data } = await requestFn.put( endpoint + param, payload)
        return data
    },
    async post(payload, url, param, requestType) {
        param = this.getParams(param)
        
        const endpoint = endpointOf(url)
        let requestFn = requestType === 'bots' ? botsRequest : authRquest
        const { data } = await requestFn.post(endpoint + param, payload )
        return data
    },
    async delete(payload, url, param, requestType) {
        param = this.getParams(param)
        
        const endpoint = endpointOf(url)
        let requestFn = requestType === 'bots' ? botsRequest : authRquest
        const { data } = await requestFn.delete( endpoint + param, payload)
        return data
    },
    
}